import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import { useForm, FieldErrors } from "react-hook-form";
import CommonForm from "Components/Common/CommonForm";
import { periodfields } from "../helper/periodconstant";
import { PeriodFormValues, PeriodRecord } from "../helper/period.types";

/* -----------------------------
 Types
----------------------------- */

interface AddEditPeriodProps {
  isOpen: boolean;
  toggle: () => void;
  existingData: PeriodRecord | null;
  onSave: (record: PeriodFormValues) => void;
  isLoading: boolean;
}

/* -----------------------------
 Component
----------------------------- */

const AddEditPeriod: React.FC<AddEditPeriodProps> = ({
  isOpen,
  toggle,
  existingData,
  onSave,
  isLoading,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<PeriodFormValues>({
    defaultValues: {
      period_sort: "",
      period_number: "",
    },
    mode: "onChange",
  });

  /* -----------------------------
   Populate data in edit mode
  ----------------------------- */
  useEffect(() => {
    if (existingData) {
      reset(existingData);
    } else {
      reset({
        period_sort: "",
        period_number: "",
      });
    }
  }, [existingData, reset, isOpen]);

  /* -----------------------------
   Submit
  ----------------------------- */
  const onSubmit = (values: PeriodFormValues): void => {
    onSave(values);
  };

  /* -----------------------------
   Render
  ----------------------------- */
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="md"
      centered
      className="common_modal"
    >
      {/* Header */}
      <ModalHeader toggle={toggle} className="fw-bold border-bottom p-3">
        {existingData
          ? `Edit Period No (${existingData.period_sort})`
          : "Add Period"}
      </ModalHeader>

      {/* Body */}
      <ModalBody>
        <form id="masterPeriodForm" onSubmit={handleSubmit(onSubmit)}>
          <CommonForm
            fields={periodfields}
            control={control}
            errors={errors as FieldErrors}
            columns={1}
            setValue={setValue}
          />
        </form>
      </ModalBody>

      {/* Footer */}
      <ModalFooter className="bg-white border-top">
        <Button outline onClick={toggle}>
          Cancel
        </Button>

        <Button
          color="primary"
          outline
          type="submit"
          form="masterPeriodForm"
          disabled={isLoading}
        >
          {isLoading && <Spinner size="sm" className="me-2" />}
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEditPeriod;